import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=030e2e44&"
import script from "./UserInvite.vue?vue&type=script&lang=js&"
export * from "./UserInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030e2e44')) {
      api.createRecord('030e2e44', component.options)
    } else {
      api.reload('030e2e44', component.options)
    }
    module.hot.accept("./UserInvite.vue?vue&type=template&id=030e2e44&", function () {
      api.rerender('030e2e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/views/UserInvite.vue"
export default component.exports